import React, { useContext } from 'react'
import AuthContext from '../contexts/AuthContext'
import { Navigate } from 'react-router-dom'

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const authContext = useContext(AuthContext)
  if (!authContext?.data?.token) {
    return <Navigate to='/login' replace />
  }

  return <React.Fragment>{children}</React.Fragment>
}
export default ProtectedRoute
